"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORM_ELEMENT_TRANSITION = void 0;
/** Transition specifically for the StyledLabel and Container in multiple components.
 * It animates color, transform, padding, and font-size properties with 0.25s duration and custom cubic-bezier easing function. **/
var FORM_ELEMENT_TRANSITION = "0.25s cubic-bezier(0.64, 0.05, 0.36, 1)";
exports.FORM_ELEMENT_TRANSITION = FORM_ELEMENT_TRANSITION;
//# sourceMappingURL=transition.js.map